<template>
  <div>
    <v-overlay v-model="isOverlay" style="zIndex: 9999" color="blue-grey darken-4">
      <svg
        width="19.341mm"
        height="22mm"
        version="1.1"
        viewBox="0 0 19.341 22"
        xmlns="http://www.w3.org/2000/svg"
        class="svg-wrap"
      >
        <g stroke-width=".002667" id="rumah">
          <path
            d="m5.6327 8.3964-3.7047 2.4055h-1.928v0.56276c0 0.31204 0.25338 0.56534 0.56275 0.56534h1.3653v3.515h-1.3653v0.56276c0 0.31204 0.2533 0.56534 0.56534 0.56534h0.80095v2.7492h0.56379v-2.7492h2.0929v2.7492h0.56431v-2.7492h2.0934v4.4385h0.56379v-0.64854h3.7264v0.64854h0.56379v-4.4385h2.0934v2.7492h0.56379v-2.7492h2.0934v2.7492h0.56379v-2.7492h0.80095c0.31204 0 0.56534-0.2533 0.56534-0.56534v-0.56276h-1.3653v-3.515h1.3653c0.30937 0 0.56276-0.2533 0.56276-0.56534v-0.56276h-1.928l-3.7047-2.4055 0.18138 1.1389 0.0346 0.21342h1.2857v0.9679l1.0749 0.69867v4.0297h-3.0458v-3.683h-7.1236v3.683h-3.0592v-4.0297l1.0749-0.69867v-0.9679h1.2857l0.03462-0.21342zm-1.6588 4.2271v1.6108h1.2242v-1.6108zm10.169 0v1.6108h1.2242v-1.6108zm-6.3355 3.9496h3.7264v0.64854h-3.7264zm0 0.93121h3.7264v0.67179h-3.7264zm0 0.95446h3.7264v0.66973h-3.7264zm0 0.9524h3.7264v0.66921h-3.7264z"
            image-rendering="optimizeQuality"
          />
        </g>
        <g stroke-width=".002667" id="atap">
          <path
            d="m5.704 0v0.56276c0 0.30937 0.25338 0.56276 0.56276 0.56276h0.96532l-0.78135 4.9341-0.56792 3.5869-0.09302 0.58704h-1.2113v0.56534c0 0.30937 0.25597 0.56276 0.56534 0.56276h9.0516c0.31203 0 0.56534-0.25338 0.56534-0.56276v-0.56534h-1.2216l-0.093-0.58704-1.3493-8.5209h0.96532c0.30937 0 0.56276-0.25338 0.56276-0.56276v-0.56276h-2.187c-0.30937 0-0.56276 0.25338-0.56276 0.56276v0.50643l-1.2108-0.0026-1.2108 0.0026v-0.50643c0-0.30937-0.25338-0.56276-0.56275-0.56276z"
            image-rendering="optimizeQuality"
          />
        </g>
      </svg>
    </v-overlay>
  </div>
</template>

<script>
export default {
  computed: {
    isOverlay() {
      return this.$store.state.overlay;
      // return true;
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_OVERLAY") {
        this.overlay = state.overlay;
      }
    });
  },
};
</script>

<style>
.svg-wrap {
  position: relative;
  overflow: visible;
}

#atap {
  fill: #FFEB3B;
  /* transform: translateY(-3px); */
  animation: pulse 0.5s infinite linear alternate;
}

#rumah {
  fill: #FFCA28;
}

@keyframes pulse {
  0% {
    transform: translateY(-0.2px);
  }
  25% {
    transform: translateY(0.2px);
  }
  60% {
    transform: translateY(0.6px);
  }
  100% {
    transform: translateY(0.9px);
  }
}
</style>